
@if (helpNode | async; as item) {
  <div class="helpWidget ">
    @if (item.uid === 'HomepageUserGuidePDFComponent') {
      <span class="userguidegrey">{{item.headline}} </span>
      <a class="userguideanchor anchorunderline" [href]="getImage(item.media)" target="_blank"><span
      class="userguideblack">{{item.h2content}}</span>
      <div class="global_blackarrow"></div>
    </a>
  }
</div>
}
